import { useState } from "react";
import IntelLayout from "../../../components/layout/layout";
import { generateTrackingObject } from "../../../core/global/global-country-functions";
import { trademoTrackingEvents } from "../../../core/global/trademo-tracking";
import RequestCenter from "../dashboard/RequestCenter";

const RequestCenterComponent = (props) => {
  const [showStatus, setShowStatus] = useState(false);
  const [showRequest, setShowRequest] = useState(false);
  const [showFrequency, setShowFrequency] = useState(false);
  const [showDataSource, setShowDataSource] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const [showAlertType, setShowAlertType] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  const callingTrackingEvents = (name) => {
    trademoTrackingEvents(name, generateTrackingObject("intel-dashboard", window.location.pathname, ""));
  };

  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      type={"requestCenter"}
      pageTitle="Request Center | Trademo Intel">
      <div
        onClick={() => {
          setShowStatus(false);
          setShowRequest(false);
          setShowFrequency(false);
          setShowDataSource(false);
          setShowDescription(false);
          setShowAlertType(false);
        }}>
        <RequestCenter showAlertType={showAlertType} setShowAlertType={setShowAlertType} showStatus={showStatus} showRequest={showRequest} setShowRequest={setShowRequest} setShowStatus={setShowStatus} callingTrackingEvents={callingTrackingEvents} setShowFrequency={setShowFrequency} showFrequency={showFrequency} showDataSource={showDataSource} setShowDataSource={setShowDataSource} showDescription={showDescription} setShowDescription={setShowDescription} plan={""} setActivetab={() => null} userPlan={props.userPlan} />
      </div>
    </IntelLayout>
  );
};

export default RequestCenterComponent;
